import { gql } from '@apollo/client';

export const GET_PEOPLE = gql`
query Users($search: String) {
  users(search: $search) {
    photoUrl
    identifier
    name
    id
    preferredName
    scriptName
    tags {
        name
    }
  }
}`;
